<app-page-title
    pageTitle="EAUTHORIZATION-MANAGMENT.DETAILS.HISTORY-PAGE-TITLE"
    [breadcrumbs]="breadcrumbsForDetails()"
    [documentId]="authDocumentInfo()?.AuthDocumentId ?? ''"
>
</app-page-title>


<div class="view-received-rights-container section-p" nz-flex nzVertical nzGap="24px">
    <app-authorization-info-content [authDocumentInfo]="authDocumentInfo()"></app-authorization-info-content>

    <div class="main-box-style">
        <app-table
            [tableColumns]="tableColumns()"
            [tableData]="tableData()">
        </app-table>
    </div>

    <div class="actions-container" nz-flex nzJustify='space-between' nzAlign="center">
        <div class="left-side">
            <button type="button" nz-button nzType="default">
                <div nz-flex nzGap="8px">
                    <nz-icon nzType="arrow-left" nzTheme="outline" />
                    @if(isSupervisorApp == null){
                        <a [routerLink]="[`/${breadcrumbsForDetails()[0].path}`]">{{'GLOBAL.BACK' | translate}}</a>
                    }
                    @else{
                        <a [routerLink]="[`/authorisations-page-supervisor`]">{{'GLOBAL.BACK' | translate}}</a>
                    }
                    
                </div>
            </button>
        </div>
    </div>
</div>